import { isDate } from './date-util'
export function generateYearArray(startDate = null, endDate = null, date) {
  const defaultDate = isDate(date) ? new Date(date).getFullYear() : new Date().getFullYear()
  const currentDate = startDate || endDate || defaultDate
  // 右边44的原因：默认最大时间为2068年 TODO:目前没有根据外部的props去计算
  const years = Array.from({ length: (endDate ? 10 : 44) }, (_, index) => {
    const value = startDate ? (currentDate + index) : (currentDate - index)
    return {
      value,
      label: value
    }
  })

  if (endDate) {
    return years.reverse()
  } else {
    return years
  }
}

function getDefaultYearData (date) {
  const startYear = Math.floor(date.getFullYear() / 10) * 10
  return Array(10).fill(0).map((_, index) => ({
    value: startYear + index,
    label: startYear + index,
  }))
}

export function generateYearData(startDate, endDate, date) {
  if (!isDate(startDate) && !isDate(endDate)) {
    return getDefaultYearData(date)
  }
  const startDateYear = isDate(startDate) ? startDate.getFullYear() : 0
  const endDateYear = isDate(endDate) ? endDate.getFullYear() : 0
  return generateYearArray(startDateYear, endDateYear, date)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/utils/year-select.js